import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseWooCommerceV2ApiService } from '../woo-commerce/api/base-woo-commerce-v2-api.service';
import {
  AddressFields,
  CreateAddressResponse,
  CouponsResponse,
  CustomerOrdersResponse,
  CustomerSubscriptionsResponse,
  DeleteAddressResponse,
  GetAddressesResponse,
  GiftCardsResponse,
  PointsBalanceResponse,
  PointsHistoryResponse,
  ReferralsResponse,
  UpdateAddressResponse,
  UpdateProfileRequest,
  UserProfile
} from '../../interfaces/user-profile/user-profile.interface';

@Injectable({
  providedIn: 'root'
})
export class UserProfileApiService extends BaseWooCommerceV2ApiService {
  getProfile(): Observable<UserProfile> {
    return this.get<any>('/customers/profile').pipe(
      map((response: any) => response?.data || response || {})
    );
  }

  updateProfile(
    body: UpdateProfileRequest
  ): Observable<UserProfile> {
    return this.put<any>('/customers/profile', body).pipe(
      map((response: any) => response?.data || response || {})
    );
  }

  getAddresses(): Observable<GetAddressesResponse> {
    return this.get<any>('/customers/addresses').pipe(
      map((response: any) => ({
        ...response,
        data: Array.isArray(response?.data)
          ? response.data
          : response?.data?.addresses || []
      }))
    );
  }

  createAddress(body: Partial<AddressFields>): Observable<CreateAddressResponse> {
    return this.post<any>('/customers/addresses', body).pipe(
      map((response: any) => response || {})
    );
  }

  updateAddress(
    id: number,
    body: Partial<AddressFields>
  ): Observable<UpdateAddressResponse> {
    return this.put<any>(`/customers/addresses/${id}`, body).pipe(
      map((response: any) => response || {})
    );
  }

  deleteAddress(id: number): Observable<DeleteAddressResponse> {
    return this.delete<any>(`/customers/addresses/${id}`).pipe(
      map((response: any) => response || {})
    );
  }

  getPoints(): Observable<PointsBalanceResponse> {
    return this.get<any>('/reward-points/my-balance').pipe(
      map((response: any) => response || {})
    );
  }

  getPointsHistory(
    page: number = 1,
    perPage: number = 20
  ): Observable<PointsHistoryResponse> {
    return this.get<any>('/reward-points/my-history', {
      params: { page, per_page: perPage }
    }).pipe(
      map((response: any) => response || {})
    );
  }

  getGiftCards(): Observable<GiftCardsResponse> {
    return this.get<any>('/customer/gift-cards').pipe(
      map((response: any) => response || {})
    );
  }

  getCoupons(): Observable<CouponsResponse> {
    return this.get<any>('/customer/coupons').pipe(
      map((response: any) => response || {})
    );
  }

  getReferrals(): Observable<ReferralsResponse> {
    return this.get<any>('/customer/referrals').pipe(
      map((response: any) => response || {})
    );
  }

  getOrders(
    page: number = 1,
    perPage: number = 20
  ): Observable<CustomerOrdersResponse> {
    return this.get<any>('/customer/orders', {
      params: { page, per_page: perPage }
    }).pipe(
      map((response: any) => response || {})
    );
  }

  getSubscriptions(
    page: number = 1,
    perPage: number = 20
  ): Observable<CustomerSubscriptionsResponse> {
    return this.get<any>('/customer/subscriptions', {
      params: { page, per_page: perPage }
    }).pipe(
      map((response: any) => response || {})
    );
  }
}
